export default __webpack_public_path__ + "static/media/orientaSexMaleFemaleIcon.91b984b6.svg";